import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";

export default function useLatestAppRelease({ enabled = true } = {}) {
  const [latestRelease, setLatestRelease] = useState(null);
  const [loading, setLoading] = useState(!!enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    const releaseRef = doc(db, "platform", "latestRelease");
    const unsubscribe = onSnapshot(
      releaseRef,
      (snap) => {
        setLatestRelease(snap.exists() ? { id: snap.id, ...snap.data() } : null);
        setError(null);
        setLoading(false);
      },
      (err) => {
        console.error("Failed to watch latest app release:", err);
        setError(err);
        setLoading(false);
      },
    );

    return unsubscribe;
  }, [enabled]);

  return { latestRelease, loading, error };
}
